export default __webpack_public_path__ + "static/media/icon-close.c7dd5b17.svg";